import type { ReactNode } from 'react'
import { ApiError } from '@/api/errors'
import { Button } from './Button'
import { Spinner } from './Spinner'

export function LoadingState({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-tg-hint">
      <Spinner />
      <span className="text-sm">{label}</span>
    </div>
  )
}

export function EmptyState({
  title = 'Пусто',
  hint,
  action,
}: {
  title?: string
  hint?: string
  action?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-16 text-center">
      <div className="text-base font-medium text-tg-text">{title}</div>
      {hint && <div className="max-w-xs text-sm text-tg-hint">{hint}</div>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const message =
    error instanceof ApiError
      ? error.message
      : error instanceof Error
        ? error.message
        : 'Что-то пошло не так'
  const offline = error instanceof ApiError && error.code === 'NETWORK'
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      <div className="text-base font-medium text-risk-red">
        {offline ? 'Нет связи с сервером' : 'Ошибка'}
      </div>
      <div className="max-w-xs text-sm text-tg-hint">{message}</div>
      {onRetry && (
        <Button variant="secondary" size="md" onClick={onRetry}>
          Повторить
        </Button>
      )}
    </div>
  )
}
